export default __webpack_public_path__ + "static/media/cow-icon.f1dfcff6.svg";